import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'brand' | 'neutral' | 'text' | 'destructive';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: React.ReactNode;
}
const base = 'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded border px-4 h-8 text-[13px] font-semibold transition-colors duration-150 ease-out disabled:cursor-not-allowed disabled:opacity-50';
const variants: Record<Variant, string> = {
  brand: 'border-leaf-600 bg-leaf-600 text-white hover:bg-leaf-500 hover:border-leaf-500',
  neutral: 'border-line-strong bg-white text-ink-700 hover:bg-[#f4f5f7] hover:border-ink-400',
  text: 'border-transparent bg-transparent px-2 text-brand-600 hover:underline',
  destructive: 'border-danger-fg bg-danger-fg text-white hover:bg-[#8e0412]'
};
export function Button({
  variant = 'neutral',
  className,
  children,
  ...rest
}: ButtonProps) {
  return <button type="button" className={twMerge(base, variants[variant], className)} {...rest} data-id="element-77" data-mp="80jrzchk7hbd">
      {children}
    </button>;
}